// // src/pages/AdminDashboard.js
// import React, { useState } from "react";
// import { Container, Row, Col, Nav } from "react-bootstrap";
// import AddCommunity from "./AddCommunity";
// import ViewCommunities from "./ViewCommunities";
// import RequestsList from "./RequestsList";

// export default function AdminDashboard() {
//   const [activeTab, setActiveTab] = useState("add");

//   const renderContent = () => {
//     switch (activeTab) {
//       case "add":
//         return <AddCommunity />;
//       case "view":
//         return <ViewCommunities />;
        
// case "requests":
//         return <RequestsList />;

//       default:
//         return <AddCommunity />;
//     }
//   };

//   return (
//     <Container fluid className="mt-4">
//       <Row>
//         {/* Sidebar */}
//         <Col md={3} className="bg-light p-3" style={{ minHeight: "100vh" }}>
//           <h4>Admin Panel</h4>
//           <Nav className="flex-column">
//             <Nav.Link onClick={() => setActiveTab("add")} active={activeTab === "add"}>
//               Add Community
//             </Nav.Link>
//             <Nav.Link onClick={() => setActiveTab("view")} active={activeTab === "view"}>
//               View Communities
//             </Nav.Link>

            
// <Nav.Link onClick={() => setActiveTab("requests")} active={activeTab === "requests"}>
//               Registration Requests
//             </Nav.Link>



//             <Nav.Link onClick={() => alert("Logging out...")}>Logout</Nav.Link>
//           </Nav>
//         </Col>

//         {/* Content Area */}
//         <Col md={9} className="p-4">
//           {renderContent()}
//         </Col>
//       </Row>
//     </Container>
//   );
// }


// src/pages/AdminDashboard.js
import React, { useState } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import AddCommunity from "./AddCommunity";
import ViewCommunities from "./ViewCommunities";
import RequestsList from "./RequestsList";
import AdminServices from "./AdminServices"; // <-- NEW

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("add");

  const renderContent = () => {
    switch (activeTab) {
      case "add":
        return <AddCommunity />;
      case "view":
        return <ViewCommunities />;
      case "requests":
        return <RequestsList />;
        case "services":
        return <AdminServices/>
     
      default:
        return <AddCommunity />;
    }
  };

  return (
    <Container fluid className="mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={3} className="bg-light p-3" style={{ minHeight: "100vh" }}>
          <h4>Admin Panel</h4>
          <Nav className="flex-column">
            <Nav.Link onClick={() => setActiveTab("add")} active={activeTab === "add"}>
              Add Community
            </Nav.Link>
            <Nav.Link onClick={() => setActiveTab("view")} active={activeTab === "view"}>
              View Communities
            </Nav.Link>
            <Nav.Link onClick={() => setActiveTab("requests")} active={activeTab === "requests"}>
              Registration Requests
            </Nav.Link>

            {/* NEW: Services tab */}
            <Nav.Link onClick={() => setActiveTab("services")} active={activeTab === "services"}>
              Services
            </Nav.Link>

            <Nav.Link onClick={() => alert("Logging out...")}>Logout</Nav.Link>
            
          </Nav>
        </Col>

        {/* Content Area */}
        <Col md={9} className="p-4">
          {renderContent()}
        </Col>
      </Row>
    </Container>
  );
}
